import React, { Component } from 'react';

const StateContext = React.createContext('test');

export class StateProvider extends Component {
    state = {
        userName:'None',
        userRole:'',
        permissions:['guest'],
        collapsed:false,
        investors:false,
        kyc_investors:false,
        drawerContent:false,
        popupContent:false,
        updateOrders:false,
        kycUpdate:false
    };

    componentWillMount(){

    }

    render() {
        const {children} = this.props;

        return (

            <React.Fragment>
                <StateContext.Provider value={{
                    ...this.state,
                    update: (obj) => {
                        this.setState(obj)
                    }
                }}>
                    {children}
                </StateContext.Provider>
            </React.Fragment>
        );
    }
}

export function withContext(ComposedComponent) {
    class withContext extends Component {
        state = {
            test: 'state'
        }

        render() {

            return (
                <StateContext.Consumer>
                    {
                        (context) => (
                            <ComposedComponent context={context} {...this.props}/>
                        )
                    }
                </StateContext.Consumer>
            );
        }
    }

    return withContext;
}



// WEBPACK FOOTER //
// ./src/yeffect/StateProvider.js